import styled from 'styled-components'
import Icon from '@/components/icon'
import { colors } from '@/styles'
import { show as showHelperModal } from './helper-modal'

const Wrapper = styled.p`
  color: ${colors.link};
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 19px;
  margin: 10px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    margin-right: 5px;
  }
`

const Helper = ({ text, title, description }) => {
  return (
    <Wrapper onClick={() => showHelperModal({ title, description })}>
      <Icon id="info_blue" width={16} height={16} />
      {text}
    </Wrapper>
  )
}

export default Helper
